<template>
  <NavigationLayout
    :navigationTitle="$t('wiseTransferHistory')"
    :navigationContentStyle="{ 'background-color': '#FAFAFA' }"
  >
    <div id="mypage__wrapper" slot="contents">
      <div id="mypage__container">
        <div class="list__wrapper" v-if="payouts.length > 0">
          <div class="list__container">
            <section v-for="(payout, index) in payouts" :key="index">
              <ListItemWithSlots>
                <template #left>{{ $t('wiseTransferRequestDate') }}</template>
                <template #right>{{ payout.transactionDate }}</template>
              </ListItemWithSlots>

              <ListItemWithSlots>
                <template #left>{{ $t('amount') }}</template>
                <template #right>{{
                  $t('dollars', { dollars: payout.amount })
                }}</template>
              </ListItemWithSlots>

              <ListItemWithSlots>
                <template #left>{{ $t('status') }}</template>
                <template #right>{{ $t(payout.status) }}</template>
              </ListItemWithSlots>
            </section>
          </div>
        </div>
        <div class="message__wrapper" v-else>
          <div class="message__container">
            <span class="message__content">{{
              $t('noWiseTransferHistory')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import NavigationLayout from '@/components/NavigationLayout.vue'
import ListItemWithSlots from '@/components/ListItemWithSlots.vue'
import { Vue, Component } from 'vue-property-decorator'
import { apiV2 } from '@/api/appGatewayServerV2Api'
import {
  HRWisePayout,
  mapToHumanRedable,
} from './helper'

@Component({
  components: {
    NavigationLayout,
    ListItemWithSlots,
  }
})
export default class WisHistoryPage extends Vue {
  payouts: HRWisePayout[] = []

  async created(): Promise<void> {
    this.fetchPayouts()
    this.fetchRate()
  }

  async fetchPayouts(): Promise<void> {
    try {
      const payouts = (await apiV2().wise.payout.list()).payouts
      if (payouts) {
        this.payouts = payouts.map((p) => mapToHumanRedable(p))
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    }
  }

  async fetchRate(): Promise<void> {
    try {
      const rate = (await apiV2().wise.rate.get()).rateOfUsd
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    }
  }
}
</script>

<style scoped>
#mypage__wrapper {
  height: 100%;
  min-height: 100%;
  background-color: #fafafa;
}

#mypage__container {
  height: 100%;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-bottom: 80px;
}

#mypage__header {
  padding: 20px 14px;
  margin-top: 0;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}

section {
  margin-top: 20px;
}

.notes__wrapper {
  padding-left: 16px;
}

.notes__container {
  font-size: 10px;
  line-height: 15px;
  font-family: 'Hiragino Sans';
  color: #808080;
}

.message__wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.message__container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.message__content {
  max-width: calc(100% - 16px * 2);
  color: #262626;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Hiragino Sans';
  font-style: normal;
  font-weight: 400;
}

.list__container {
  padding-bottom: 8px;
  background-color: #fafafa;
}
</style>
